<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18">
    <slot />
    <path
      :fill="color"
      d="M14.5 0c.887 0 1.433.494 1.494 1.338L16 1.5v12c0 .761-.363 1.27-.999 1.44L15 17h.5c.276 0 .5.224.5.5 0 .245-.177.45-.41.492L15.5 18h-13C.897 18 .06 16.832.003 14.737L0 14.5V3C0 1.127.983.077 2.795.004L3 0h11.5zM14 15H2.5c-.413 0-.753.34-1.026 1.158-.02.058-.048.11-.085.156l-.045.045.063.101c.226.336.547.507.965.536L2.5 17H14v-2zm.5-14H3c-1.33 0-1.946.558-1.997 1.823L1 3v11.613l.007.228.035-.05c.342-.468.775-.739 1.298-.784L2.5 14h12c.355 0 .478-.09.497-.4l.003-.1v-12c0-.355-.09-.478-.4-.497L14.5 1zm-6 2C10.985 3 13 5.015 13 7.5S10.985 12 8.5 12 4 9.985 4 7.5 6.015 3 8.5 3zM7.01 8H5.035c.195 1.362 1.173 2.47 2.463 2.855-.267-.72-.448-1.724-.49-2.855zm4.954 0H9.991c-.042 1.13-.223 2.135-.49 2.854 1.29-.384 2.268-1.492 2.463-2.853zm-2.974.002h-.98c.037.913.172 1.746.378 2.364l.052.148.06.147.06-.147.052-.148c.206-.618.341-1.45.378-2.364zM7.5 4.146l-.106.032C6.156 4.591 5.224 5.676 5.035 7H7.01c.042-1.13.223-2.134.49-2.854zm1 .192l-.007.015c-.035.084-.07.178-.105.281-.206.618-.342 1.451-.378 2.365h.98c-.036-.914-.172-1.747-.378-2.365l-.052-.148-.06-.148zm1-.193l.005.014c.265.719.445 1.718.486 2.842L11.965 7C11.77 5.638 10.79 4.53 9.5 4.145z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
